/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.publicALaCarteProducts.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * A list of a la carte products available to all users.
 */
@ExperimentalJsExport
@JsExport
@Serializable
data class PublicALaCarteProductsModel(
    /** A list of a la carte products available to all users. */
    @SerialName("data")
    val data: AlaCarteList?
) : Model()
